import { PayoutRules_t } from "../models/payout-rules-model";
import { ApiRequest, fetchDataFromAPITyped } from "../services/api-requests";

export const savePayoutRules = async (payoutRules: PayoutRules_t) => {
    const apiQuery: ApiRequest = {
        route: "payouts/rules",
        request: {
            method: 'POST',
            entity: 'payout',
            body: payoutRules
        }
    }
    return await fetchDataFromAPITyped<PayoutRules_t>(apiQuery);
}